/*
 Copyright 2024 European Commission

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

      https://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
 */

import React, { Component } from "react";
import "./Home.css";

class Home extends Component {
  render() {
    return (
      <div style={{ width: "100%", margin: "auto" }} className="home-container">
        <div className="row mt-5">
          <div className="col-md-12 text-center mb-4">
            <h1 className="home-left-title  text-white">
              Sign PDF documents with Scytáles Wallet 
            </h1>
            <img src="/Images/document.png" width={100} alt="Home" className="home-right-image my-3" />

            <h4 className="home-left-subtitle  text-white">
              Use your Scytáles Wallet to securely sign PDF documents online.
            </h4>
          </div>
        </div>
        <h1 className="home-title">Login to sign PDF Scytáles Documents</h1>
        <a href="/login" className="btn btn-light font-size-xl btnContact w-50 shadow roboto-condensed-300 mt-3">LOG IN</a>
      </div>
    );
  }
}

export default Home;
